import { createReducer } from "@reduxjs/toolkit";
import {
  LOAD_SELLERS_SUCCESS,
  SET_ACTIVE_SELLER,
  LOAD_ALL_SELLERS_REQUEST,
  LOAD_ALL_SELLERS_SUCCESS,
  LOAD_ALL_SELLERS_FAIL,
  SET_ACTIVE_SELLER_PROFILE,
  FETCH_SHOP_AND_SUBSCRIPTIONS_REQUEST,
  FETCH_SHOP_AND_SUBSCRIPTIONS_SUCCESS,
  FETCH_SHOP_AND_SUBSCRIPTIONS_FAILURE,
  SET_SELLER_ON_LOGIN
} from "../actions/user";
import { getCachedUserShops } from "../../utils/authSession";
import { getStoredCurrentProfile, isShopProfile } from "../../utils/shopProfile";

const cachedSellers = getCachedUserShops();
const cachedCurrentProfile = getStoredCurrentProfile();
const cachedActiveSeller = isShopProfile(cachedCurrentProfile)
  ? cachedSellers.find((seller) => seller.name === cachedCurrentProfile) || null
  : null;

const initialState = {
  isLoading: cachedSellers.length === 0,
  isSeller: Boolean(cachedActiveSeller || cachedSellers.length > 0),
  seller: cachedActiveSeller,
  activeSeller: cachedActiveSeller,
  sellers: cachedSellers, 
  allSellers: [],
  activeSellerIndex: 0,
  shopDetails: null,
  shopSubscriptions: [],
};

export const sellerReducer = createReducer(initialState, {
  LoadSellerRequest: (state) => {
    state.isLoading = true;
  },
  ClearSellerState: (state) => {
    state.isLoading = false;
    state.isSeller = false;
    state.seller = null;
    state.activeSeller = null;
    state.error = null;
  },
  LoadSellerSuccess: (state, action) => {
    state.isSeller = true;
    state.isLoading = false;
    state.seller = action.payload;
  },
  LoadSellerFail: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
    state.isSeller = false;
  },
  [SET_SELLER_ON_LOGIN]: (state, action) => {
    state.isSeller = true;
    state.isLoading = false;
    state.seller = action.payload;
    state.activeSeller = action.payload;
  },

  [LOAD_ALL_SELLERS_REQUEST]: (state) => {
    state.isLoading = true;
  },
  [LOAD_ALL_SELLERS_SUCCESS]: (state, action) => {
    state.isLoading = false;
    state.allSellers = action.payload;
    state.error = null;
  },
  [LOAD_ALL_SELLERS_FAIL]: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  [SET_ACTIVE_SELLER_PROFILE]: (state, action) => {
    state.activeSellerIndex = action.payload;
   
  },

  [LOAD_SELLERS_SUCCESS]: (state, action) => {
    state.isLoading = false;
    state.sellers = Array.isArray(action.payload) ? action.payload : [];
    state.isSeller = state.sellers.length > 0;
  },

  [SET_ACTIVE_SELLER]: (state, action) => {
    console.log('Updating state with new active seller:', action.payload);
    state.isSeller = true;
    state.isLoading = false;
    state.seller = action.payload;
    state.activeSeller = action.payload;
    state.error = null;
  },

  [FETCH_SHOP_AND_SUBSCRIPTIONS_REQUEST]: (state) => {
    state.isLoading = true;
  },
  [FETCH_SHOP_AND_SUBSCRIPTIONS_SUCCESS]: (state, action) => {
    state.isLoading = false;
    state.seller = action.payload.shop;
    state.subscriptions = action.payload.subscriptions;
  },
  [FETCH_SHOP_AND_SUBSCRIPTIONS_FAILURE]: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  // get all sellers ---admin
  getAllSellersRequest: (state) => {
    state.isLoading = true;
  },
  getAllSellersSuccess: (state, action) => {
    state.isLoading = false;
    state.sellers = action.payload;
  },
  getAllSellerFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },
  clearErrors: (state) => {
    state.error = null;
  },
});
